import styled, {css} from 'styled-components';
import {AlertTypes, AlertSizes} from './constants';

export const StyledIcon = styled.div<{size: AlertSizes}>`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Container = styled.div<{type: AlertTypes; size: AlertSizes}>`
  display: flex;
  border-radius: 10px;
  gap: 12px;
  max-width: 400px;

  ${props => {
    switch (props.size) {
      case AlertSizes.S:
        return css`
          padding: 12px 8px;
          font-size: 14px;
          font-weight: 500;
          align-items: flex-start;
        `;
      case AlertSizes.M:
        return css`
          padding: 16px;
          font-size: 16px;
          font-weight: 500;
          align-items: flex-start;
        `;
      case AlertSizes.L:
      default:
        return css`
          padding: 20px 24px;
          align-items: center;
        `;
    }
  }}

  ${props => {
    switch (props.type) {
      case AlertTypes.INFO:
        return css`
          background: rgba(239, 246, 255, 1);
          color: var(--primary, #385bf8);

          ${StyledIcon} svg {
            color: var(--primary, #385bf8);
          }
        `;
      case AlertTypes.WARNING:
      default:
        return css`
          background: rgba(255, 196, 0, 0.3);
          color: var(--gray-dark, #374151);

          ${StyledIcon} svg {
            color: var(--icon-warning, #f59e0b);
          }
        `;
    }
  }}
`;

export const Content = styled.div`
  max-width: 1024px;
  text-align: left;
  font-weight: 500;

  @media (min-width: 1024px) {
    max-width: 100%;
  }
`;
